module.exports = __webpack_public_path__ + "static/media/GiftCard_Landing.2a9b4aa2.jpg";